import { historyEventService } from './httpService'
import { historyService } from './historyService'
import { globalService } from './globalService'
export default class historyColumnService {
  constructor (module, url, flag, param, source) {
    this.module = module
    this.url = url
    this.flag = flag
    this.param = param
    this.source = source
  }

  getColumns () {
    var me = this
    me.module.moreList = []
    me.module.gambitList = {}
    me.module.nameList = []
    me.module.documentData = {}
    historyEventService.loadColums(me.url, me.param).then(
      function (res) {
        if (res.status === 200) {
          if (!me.source) {
            me.module.moreList = historyService.handleEventData(res, me.flag)
          } else {
            if (me.flag) {
              me.module.moreList = historyService.handleEventData(
                res,
                me.flag === 1
              )
            } else {
              me.module.nameList = res.data
            }
          }
          me.module.moduleLoading = false
        }
      },
      error => globalService.showErrNofify(error)
    )
  }
  checkColumnDetail () {
    var me = this
    me.module.nameList = []
    me.module.moreList = []
    me.module.gambitList = {}
    me.module.documentData = {}
    historyEventService.loadColums(me.url).then(
      res => {
        me.module.gambitList = res.data
        if (me.module.routeList) {
          me.module.routeList.forEach(item => {
            if (item.type === 'column') {
              item.name = res.data.Name
            }
          })
        }
        me.module.moduleLoading = false
      },
      error => globalService.showErrNofify(error)
    )
  }
}



// WEBPACK FOOTER //
// ./src/service/historyColumnService.js